import React, { useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext, getIn } from 'formik';
import { lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';
import Divider from 'core/components/divider';
import Label from 'core/components/label/label';

import useStyles from './exclusions.styles';

const RoofExclusionSection = ({ fieldName, disabled }) => {
  const classes = useStyles();
  const { values, initialValues, setFieldValue } = useFormikContext();

  const initialRoofLossSettlement = getIn(initialValues, `${fieldName}.roofLossSettlement`);
  const roofExclusion = getIn(values, `${fieldName}.roofExclusion`);
  const [isSectionOpen, setIsSectionOpen] = useState(roofExclusion && roofExclusion !== 'none');

  return (
    <Grid item xs={12}>
      <div className={classes.container}>
        <Grid container>
          <Field
            xs={12}
            type="switch"
            id={`${fieldName}.roofExclusionEnabled`}
            name={`${fieldName}.roofExclusionEnabled`}
            mode="dark"
            label="Roof exclusion/restriction"
            disabled={disabled}
            value={isSectionOpen}
            onChange={(_e, checked) => {
              setIsSectionOpen(checked);
              if (checked) {
                if (roofExclusion) {
                  return;
                }

                setFieldValue(`${fieldName}.roofExclusion`, lookupsJson.farm.roofExclusion[0].id);
              } else {
                setFieldValue(`${fieldName}.roofLossSettlement`, initialRoofLossSettlement);

                setFieldValue(`${fieldName}.roofExclusion`, 'none');
                setFieldValue(`${fieldName}.roofExclusionDetails`, undefined);
              }
            }}
          />
        </Grid>
        {isSectionOpen && (
          <>
            <Divider className={classes.divider} />
            <Label className={classes.label}>Roof exclusion/restriction</Label>
            <Grid container spacing={2}>
              <Field
                xs={12}
                type="select"
                id={`${fieldName}.roofExclusion`}
                name={`${fieldName}.roofExclusion`}
                mode="dark"
                label="Roof exclusion type"
                options={lookupsJson.farm.roofExclusion}
                disabled={disabled}
              />
              <Field
                xs={12}
                type="textarea"
                id={`${fieldName}.roofExclusionDetails`}
                name={`${fieldName}.roofExclusionDetails`}
                mode="dark"
                label="Description of reason for for excluding the selected items (required)"
                rows={3}
                disabled={disabled}
              />
            </Grid>
          </>
        )}
      </div>
    </Grid>
  );
};

RoofExclusionSection.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

RoofExclusionSection.defaultProps = {
  disabled: false
};

export default observer(RoofExclusionSection);
